import { Component, type OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DbDiagnosticProvider } from "../../../../../../shared/cw-backend/providers/attendance/dbdiagnostic/db-diagnostic.provider";
import { CwUtils, SnackBarService } from "cw-utils";
import { Router } from "@angular/router";

@Component({
    selector: "app-dialog-db-procedure",
    templateUrl: "./dialog-db-procedure.component.html",
    styleUrls: ["./dialog-db-procedure.component.scss"],
})
export class DialogDbProcedureComponent implements OnInit {
    form: FormGroup;
    displayedColumns: string[] = [
        "send",
        "procedureCode",
        "procedureName",
        "material",
        "volume",
        "status",
    ];
    // Removed lab exams section per new requirement
    isLoading: boolean = false;
    tableName!: string;
    title = "Procedimentos para DB-Diagnostico";

    constructor(
        public _matDialogRef: MatDialogRef<DialogDbProcedureComponent>,
        private dbDiagnosticProvider: DbDiagnosticProvider,
        private snackBar: SnackBarService,
        private readonly formBuilder: FormBuilder,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.form = this.formBuilder.group({
            services: this.formBuilder.array([]),
        });
    }

    ngOnInit(): void {
        this.getProcedureOrder(this.data.id);

        console.log("🚀 ~ DialogDbProcedureComponent ~ ngOnInit ~ this.tableName:", this.tableName)
        if (this.tableName == "Labchekap") {
            this.title = "Procedimentos para Labchecap";
        } else if (this.tableName == "LabAlvaro") {
            this.title = "Procedimentos para LabAlvaro";
        }
    }

    get services(): FormArray {
        return this.form.get("services") as FormArray;
    }

    getProcedureOrder(orderId: number) {
        this.dbDiagnosticProvider
            .getProcedureByOrder(orderId, this.tableName)
            .then((res) => {
                this.setServices(res.body);
            });
    }

    private createServiceGroup(service: any): FormGroup {
        return this.formBuilder.group({
            orderCollectId: [service?.orderCollectId],
            send: [
                {
                    value: service?.orderCollectId
                        ? service.send
                        : service?.procedureCodeDB != null
                            ? true
                            : false,
                    disabled: service?.procedureCodeDB == null ? true : false,
                },
            ],
            orderId: [service?.orderId],
            orderItemId: [service?.orderItemId ?? null],
            procedureNameDB: [
                service?.procedureNameDB || service?.procedureName,
            ],
            procedureName: [service?.procedureName],
            procedureCodeDB: [service?.procedureCodeDB],
            procedureCode: [service?.procedureCode],
            requiredVolume: [service?.requiredVolume],
            requiredHeight: [service?.requiredHeight],
            requiredWeight: [service?.requiredWeight],
            volume: [
                {
                    value: service?.volume,
                    disabled: service?.requiredVolume == 0 ? true : false,
                },
            ],
            material: [service?.material],
            status: [service?.status],
            methodology: [service?.methodology],
        });
    }

    setServices(services: any[]): void {
        this.services.clear();
        setTimeout(() => {
            services.forEach((svc) =>
                this.services.push(this.createServiceGroup(svc)),
            );
        }, 500);
        // this.updateDisplayedColumns();
    }

    onSave(): void {
        if (this.form.invalid || this.isLoading) {
            this.form.markAllAsTouched();
            return;
        }
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        const selectCheck = (this.form.value.services || []).filter(
            (s: any) =>
                (s?.send === 1 || s?.send === true) && s?.status == null,
        );

        if (selectCheck.length > 0) {
            const selected = this.form.value.services;
            selected.map((s: any) => {
                if (s.send == true) {
                    s.send = 1;
                }
                if (s.send == false) {
                    s.send = 0;
                }
            });
            if (this.tableName == "Labchekap") {
                this.sendProcedureLabcheckap(selected);
            } else if (this.tableName == "LabAlvaro") {
                this.sendProcedureLabAlvaro(selected);
            }
            else {
                this.sendProcedure(selected);
            }
        } else {
            this.snackBar.warnMessage(
                "Nenhum procedimento pendente para envio!",
            );
            this.isLoading = false;
        }
    }

    sendProcedure(procedure: any) {
        this.dbDiagnosticProvider
            .receivesCare(procedure)
            .then((res) => {
                this.getProcedureOrder(this.data.id);
                this.isLoading = false;
                if (
                    res.body.data?.responseMessageTOList &&
                    res.body.data?.responseMessageTOList.length > 0
                ) {
                    this.snackBar.notifierMessage(
                        "simpleDetail",
                        "Aviso",
                        res.body.data?.responseMessageTOList,
                    );
                } else {
                    this.snackBar.successMessage(res.body.message);
                }
            })
            .catch((err) => {
                this.isLoading = false;
                this.snackBar.notifierMessage(
                    "simpleMessage",
                    "Erro no Envio",
                    Array(CwUtils.formatXML(err.error.message)),
                );
            });
    }

    sendProcedureLabcheckap(procedure: any) {
        this.dbDiagnosticProvider
            .receivesCareLabchekap(procedure)
            .then((res) => {
                this.getProcedureOrder(this.data.id);
                this.isLoading = false;
                if (
                    res.body.data?.responseMessageTOList &&
                    res.body.data?.responseMessageTOList.length > 0
                ) {
                    this.snackBar.notifierMessage(
                        "simpleDetail",
                        "Aviso",
                        res.body.data?.responseMessageTOList,
                    );
                } else {
                    this.snackBar.successMessage(res.body.message);
                }
            })
            .catch((err) => {
                this.isLoading = false;
                this.snackBar.notifierMessage(
                    "simpleMessage",
                    "Erro no Envio",
                    Array(CwUtils.formatXML(err.error.message)),
                );
            });
    }

    sendProcedureLabAlvaro(procedure: any) {
        this.dbDiagnosticProvider
            .receivesCareLabAlvaro(procedure)
            .then((res) => {
                this.getProcedureOrder(this.data.id);
                this.isLoading = false;
                if (
                    res.body.data?.responseMessageTOList &&
                    res.body.data?.responseMessageTOList.length > 0
                ) {
                    this.snackBar.notifierMessage(
                        "simpleDetail",
                        "Aviso",
                        res.body.data?.responseMessageTOList,
                    );
                } else {
                    this.snackBar.successMessage(res.body.message);
                }
            })
            .catch((err) => {
                this.isLoading = false;
                this.snackBar.notifierMessage(
                    "simpleMessage",
                    "Erro no Envio",
                    Array(CwUtils.formatXML(err.error.message)),
                );
            });
    }

    checkStatus(): void {
        if (this.isLoading == true) {
            return;
        }
        this.isLoading = true;

        if (this.tableName == "Labchekap") {
            this.getStatusLabChekap();
        } else if (this.tableName == "LabAlvaro") {
            this.getStatusLabAlvaro();
        } else {
            this.getStatusDBDiagnostic();
        }
    }

    getStatusLabAlvaro() {
        this.dbDiagnosticProvider
            .checkStatusLabAlvaro(this.data.id)
            .then((res) => {
                this.setServices(res.body.data);
                this.isLoading = false;
            })
            .catch((err) => {
                this.isLoading = false;
                this.snackBar.notifierMessage(
                    "simpleMessage",
                    "Erro na Consulta",
                    Array(err?.error?.message || "Não foi possível consultar o status."),
                );
            });
    }

    getStatusDBDiagnostic() {
        this.dbDiagnosticProvider
            .checkStatus(this.data.id)
            .then((res) => {
                this.setServices(res.body.data);
                this.isLoading = false;
            })
            .catch((err) => {
                this.isLoading = false;
            });
    }

    getStatusLabChekap() {
        this.dbDiagnosticProvider
            .checkStatusLabcheckap(this.data.id)
            .then((res) => {
                this.setServices(res.body.data);
                this.isLoading = false;
            })
            .catch((err) => {
                this.isLoading = false;
            });
    }

    getResult() {
        if (this.isLoading == true) {
            return;
        }
        this.isLoading = true;

        if (this.tableName == "Labchekap") {
            this.getResultLabchekap();
        } else if (this.tableName == "LabAlvaro") {
            this.getResultLabAlvaro();
        } else {
            this.getResultdbDiagnostic();
        }
    }

    getResultLabAlvaro() {
        this.dbDiagnosticProvider
            .getResultLabAlvaro(this.data.id)
            .then((res) => {
                if (res) {
                    this.openPdf(res.body.data);
                }
                this.isLoading = false;
            })
            .catch((err) => {
                this.isLoading = false;
                this.snackBar.notifierMessage(
                    "simpleMessage",
                    "Erro no Download",
                    Array(err?.error?.message || "Não foi possível baixar o resultado."),
                );
            });
    }

    getResultdbDiagnostic() {
        this.dbDiagnosticProvider
            .getResult(this.data.id)
            .then((res) => {
                if (res.body.data) {
                    window.open(res.body.data, "_blank", "noopener,noreferrer");
                }
                this.isLoading = false;
            })
            .catch((err) => {
                this.isLoading = false;
            });
    }

    getResultLabchekap() {
        this.dbDiagnosticProvider
            .getResultLabchekap(this.data.id)
            .then((res) => {
                if (res) {
                    this.openPdf(res.body.data)
                }
                this.isLoading = false;
            })
            .catch((err) => {
                this.isLoading = false;
            });
    }

    dimiss() {
        this._matDialogRef.close();
    }

    openPdf(base64: string) {
        const cleaned = base64.replace(/^data:application\/pdf;base64,/, "");

        const byteCharacters = atob(cleaned);

        const byteArray = new Uint8Array(
            Array.from(byteCharacters).map((c) => c.charCodeAt(0)),
        );

        const blob = new Blob([byteArray], {
            type: "application/pdf",
        });

        const url = URL.createObjectURL(blob);

        window.open(url, "_blank");

        setTimeout(() => URL.revokeObjectURL(url), 60000);
    }
}
